import {useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, p} from "@pg-design/helpers-css/";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {useABTest} from "@pg-mono/ab-testing";
import {useElementWasVisible} from "@pg-mono/hooks";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {OfferType} from "../../types/OfferType";
import {offerOpinionLS} from "../../utils/offer_opinion_cookies";
import {OfferDetailOpinionsForm} from "./OfferDetailOpinionsForm";
import {OfferDetailOpinionsResults} from "./OfferDetailOpinionsResults";
import {OfferDetailOpinionsSuccess} from "./OfferDetailOpinionsSuccess";

interface Props {
    offer: {
        type: OfferType;
        id: number;
    };
    property?: {
        id: number;
    };
}

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.OPINIONS_USER_INTEREST);
const pollElementId = "poll_user_interest";

export const OfferDetailOpinions = (props: Props) => {
    const [opinionsState, setOpinionsState] = useState<"loader" | "form" | "success" | "results">("loader");

    const testProps = useABTest(abTestProps);
    const onElementVisible = () => {
        const isOpinionSent = offerOpinionLS.getIsOpinionSent(props.offer.id);
        if (isOpinionSent) {
            setOpinionsState("success");
            return;
        }

        setOpinionsState(testProps.abTestVariant === 1 ? "results" : "form");
    };

    useElementWasVisible({
        ids: [pollElementId],
        onElementVisible,
        threshold: 0.1,
        once: true
    });

    switch (opinionsState) {
        case "form":
            return (
                <div css={outerWrapper}>
                    <OfferDetailOpinionsForm offer={props.offer} property={props.property} onSubmit={() => setOpinionsState("success")} />
                </div>
            );
        case "success":
            return (
                <div css={[outerWrapper, successStyle]}>
                    <OfferDetailOpinionsSuccess />
                </div>
            );
        case "results":
            return (
                <div css={outerWrapper}>
                    <OfferDetailOpinionsResults
                        offerId={props.offer.id}
                        propertyId={props.property?.id}
                        onButtonClick={() => setOpinionsState("form")}
                        onError={() => setOpinionsState("form")}
                    />
                </div>
            );
        case "loader":
            return (
                <div data-id={pollElementId} css={outerWrapper}>
                    <Loader css={opinionsPollLoaderStyle} />
                </div>
            );
    }
};

export const OPINIONS_CONTAINER_NAME = "opinions_container";
const outerWrapper = css`
    ${borderRadius(2)}
    ${p(3, 3, 4, 3)}
    background-color: #fff;
    container-type: inline-size;
    container-name: ${OPINIONS_CONTAINER_NAME};
`;

const successStyle = css`
    background-color: ${getThemeVariable("colors.success")};
`;

export const opinionsPollLoaderStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;

    // minimize layout shifts by setting variable loader height
    height: 280px;
    @container ${OPINIONS_CONTAINER_NAME} (min-width: 700px) {
        height: 264px;
    }
`;
import {useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, p} from "@pg-design/helpers-css/";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {useABTest} from "@pg-mono/ab-testing";
import {useElementWasVisible} from "@pg-mono/hooks";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {OfferType} from "../../types/OfferType";
import {offerOpinionLS} from "../../utils/offer_opinion_cookies";
import {OfferDetailOpinionsForm} from "./OfferDetailOpinionsForm";
import {OfferDetailOpinionsResults} from "./OfferDetailOpinionsResults";
import {OfferDetailOpinionsSuccess} from "./OfferDetailOpinionsSuccess";

interface Props {
    offer: {
        type: OfferType;
        id: number;
    };
    property?: {
        id: number;
    };
}

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.OPINIONS_USER_INTEREST);
const pollElementId = "poll_user_interest";

export const OfferDetailOpinions = (props: Props) => {
    const [opinionsState, setOpinionsState] = useState<"loader" | "form" | "success" | "results">("loader");

    const testProps = useABTest(abTestProps);
    const onElementVisible = () => {
        const isOpinionSent = offerOpinionLS.getIsOpinionSent(props.offer.id);
        if (isOpinionSent) {
            setOpinionsState("success");
            return;
        }

        setOpinionsState(testProps.abTestVariant === 1 ? "results" : "form");
    };

    useElementWasVisible({
        ids: [pollElementId],
        onElementVisible,
        threshold: 0.1,
        once: true
    });

    switch (opinionsState) {
        case "form":
            return (
                <div css={outerWrapper}>
                    <OfferDetailOpinionsForm offer={props.offer} property={props.property} onSubmit={() => setOpinionsState("success")} />
                </div>
            );
        case "success":
            return (
                <div css={[outerWrapper, successStyle]}>
                    <OfferDetailOpinionsSuccess />
                </div>
            );
        case "results":
            return (
                <div css={outerWrapper}>
                    <OfferDetailOpinionsResults
                        offerId={props.offer.id}
                        propertyId={props.property?.id}
                        onButtonClick={() => setOpinionsState("form")}
                        onError={() => setOpinionsState("form")}
                    />
                </div>
            );
        case "loader":
            return (
                <div data-id={pollElementId} css={outerWrapper}>
                    <Loader css={opinionsPollLoaderStyle} />
                </div>
            );
    }
};

export const OPINIONS_CONTAINER_NAME = "opinions_container";
const outerWrapper = css`
    ${borderRadius(2)}
    ${p(3, 3, 4, 3)}
    background-color: #fff;
    container-type: inline-size;
    container-name: ${OPINIONS_CONTAINER_NAME};
`;

const successStyle = css`
    background-color: ${getThemeVariable("colors.success")};
`;

export const opinionsPollLoaderStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;

    // minimize layout shifts by setting variable loader height
    height: 280px;
    @container ${OPINIONS_CONTAINER_NAME} (min-width: 700px) {
        height: 264px;
    }
`;
